import type {Component} from 'typings/portaro.fe.types';
import type {ModalWindowBindings, ModalWindowResolveValues} from '../conversation';
import type {IOnInit} from 'angular';
import type {Department} from 'typings/portaro.be.types';
import {createPayloadActionResponse} from '../modal-utils';
import KpValueEditor from '../../value-editors/kp-value-editor/KpValueEditor.svelte';
import CustomAcceptableEditorOption from './CustomAcceptableEditorOption.svelte';
import type {SvelteComponentConstructor} from '../../../svelte/types';
import type {SingleAcceptableValueEditorOptions} from '../../value-editors/editors/single-acceptable/types';

export interface CatalogueSelectionModalModel {
    [url: string]: Department;
}

export interface SelectableCatalogue {
    url: string,
    department: Department
}

export class CatalogueSelectionModalComponentController implements ModalWindowBindings<CatalogueSelectionModalModel>, IOnInit {
    public resolve: ModalWindowResolveValues<CatalogueSelectionModalModel>;

    public kpValueEditorComponent = KpValueEditor;
    public valueEditorOptions: SingleAcceptableValueEditorOptions<SelectableCatalogue>;

    public $onInit(): void {
        const catalogues: SelectableCatalogue[] = Object.keys(this.resolve.model).map((key) => ({
            url: key,
            department: this.resolve.model[key]
        }));
        this.valueEditorOptions = {
            acceptableValues: catalogues,
            switchToInlineModeThreshold: 0,
            optionIdResolver: ({option}) => option.department.id,
            optionLabelComponent: CustomAcceptableEditorOption as SvelteComponentConstructor<{option: SelectableCatalogue}>
        }
    }

    public selectCatalogue(selectedCatalogue: SelectableCatalogue) {
        this.resolve.modalWindowActions.submitPromise(Promise.resolve(createPayloadActionResponse(selectedCatalogue.url)));
    }

    public continue() {
        this.resolve.modalWindowActions.cancel();
    }
}

/**
 * @ngdoc component
 * @name catalogueSelectionModal
 * @module portaro.conversation
 *
 * @description
 *
 */
export default class CatalogueSelectionModalComponent implements Component<ModalWindowBindings<CatalogueSelectionModalModel>> {
    public static componentName = 'catalogueSelectionModal';

    public templateUrl = require('./catalogue-selection-modal.tpl.ftl');

    public bindings = {
        resolve: '<'
    } as const;

    public controller = CatalogueSelectionModalComponentController;
}

